import { render, staticRenderFns } from "./LogoItem.vue?vue&type=template&id=90dca92a&scoped=true"
import script from "./LogoItem.vue?vue&type=script&lang=js"
export * from "./LogoItem.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/LogoItem/LogoItem.less?vue&type=style&index=0&id=90dca92a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dca92a",
  null
  
)

export default component.exports